<ng-container *transloco="let t; read: 'ime.components.edit-modal'">
  <div class="modal-footer" *ngIf="insideFooter; else separate">
    <ng-container [ngTemplateOutlet]="buttons"></ng-container>
  </div>
  <ng-template #separate>
    <ng-container [ngTemplateOutlet]="buttons"></ng-container>
  </ng-template>
  <ng-template #buttons>
    <ng-container *ngIf="requiredPrivileges | userHasPrivilege">
      <button type="button" class="btn btn-outline-danger me-1" *ngIf="hasDeleteButton" (click)="deleteClicked()">
        {{t('Delete')}}
      </button>
      <button type="button" class="btn btn-outline-primary me-1 position-relative" *ngIf="entityId" (click)="saveClick.emit(false)">
        {{t('Apply')}}
      </button>
      <button type="button" class="btn btn-outline-warning me-1" *ngIf="hasForceSaveButton" (click)="forceSaveClick.emit()">
        {{t('Force Save')}}
      </button>
      <button type="button" class="btn btn-outline-primary me-1 position-relative" *ngIf="entityId" (click)="saveClick.emit(true)">
        <span *ngIf="!isPristine" class="position-absolute top-0 start-100 translate-middle p-1 bg-primary border border-light rounded-circle"></span>
        {{t('Save')}}
      </button>
      <button type="button" class="btn btn-outline-primary me-1" *ngIf="!entityId" (click)="addClick.emit()">
        {{t('Add new')}}
      </button>
    </ng-container>
    <button type="button" class="btn btn-outline-default" (click)="cancelClick.emit()" data-dismiss="modal">
      {{t('Cancel')}}
    </button>
  </ng-template>
</ng-container>
